<template>
  <div class="login-page">
    <!--顶部 Logo-->
    <div class="login-header" @click="toHome">
      <img class="logo-img" src="../../assets/lyjy_color.png" alt="">
      <div class="logo-text">
        <div class="logo-name">精准教研</div>
        <div class="logo-slogan">赋能教师专业化成长</div>
      </div>
    </div>

    <!--注册卡片-->
    <div class="login-card">
      <div class="login-form-wrap">
        <p class="login-type">注册</p>
        <el-form ref="resetPwdFormRef" :model="resetPwdForm" :rules="resetPwdFormRules" size="large">
          <el-form-item prop="trueName">
            <el-input type="text" v-model="resetPwdForm.trueName" placeholder="请输入姓名" prefix-icon="User"></el-input>
          </el-form-item>
          <el-form-item prop="orgId">
            <el-select style="width: 100%;" filterable v-model="resetPwdForm.orgId" placeholder="请选择学校"
              prefix-icon="HomeFilled">
              <el-option v-for="item in orgList" :key="item.orgId" :label="item.orgName" :value="item.orgId" />
            </el-select>
          </el-form-item>
          <el-form-item prop="username">
            <el-input auto-complete='off' type="text" v-model="resetPwdForm.username" placeholder="请输入注册手机号"
              prefix-icon="Iphone"></el-input>
          </el-form-item>
          <el-form-item prop="fdsfds">
            <el-input auto-complete='off' type="text" v-model="resetPwdForm.code" placeholder="请输入6位数字验证码"
              prefix-icon="Message">
              <template #append>
                <el-button class="code-btn" type="primary" @click="getCode" :loading="codeBtnLoading">{{ msgText }}</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item prop="password">
            <el-input class="pwds" auto-complete='off' type="password" show-password v-model="resetPwdForm.password"
              placeholder="请输入密码" prefix-icon="Lock"></el-input>
          </el-form-item>
          <el-form-item prop="newPassword">
            <el-input class="pwds" auto-complete='off' type="password" show-password v-model="resetPwdForm.newPassword"
              placeholder="请再次输入新密码" prefix-icon="Lock"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="loginBtn" type="primary" @click="handleResetPwd" :loading="resetPwdBtnLoading">注册</el-button>
          </el-form-item>
        </el-form>
        <div class="other-tab">
          <a @click="toPwdLogin">密码登录</a>
          <a @click="toCodeLogin">验证码登录</a>
        </div>
      </div>
      <!--底部版权-->
      <div class="login-footer">
        版权所有©精准教研 | <a target="_blank" href="https://beian.miit.gov.cn">京ICP备2024046812号-6</a>
      </div>
    </div>

    <!--右侧人物-->
    <img class="login-people" src="../../assets/screen/people.png" alt="">
  </div>
</template>

<script>
import { orgListTypeOrg } from "@/api/admin/system";
import { authserviceSchoolList } from "@/api/admin/public"
const MSGINIT = "获取验证码";
const MSGSCUCCESS = "${time}秒后重发";
const MSGTIME = 60;
import { register, userHasReg, requestCode } from "@/api/user/login";
let validateUsername = (rule, value, callback) => {
  userHasReg(value).then(res => {
    const result = res.data.data
    if (!result) {
      callback(new Error("该账号尚未注册"))
    } else {
      callback()
    }
  })
}
export default ({
  name: "register",
  data() {
    return {
      orgList: [],
      msgText: MSGINIT,
      msgTime: MSGTIME,
      msgKey: false,
      codeBtnLoading: false,
      resetPwdBtnLoading: false,
      /*登录数据绑定对象*/
      resetPwdForm: {
        username: "",
        code: "",
        password: "",
        newPassword: "",
        orgId: '',
      },
      codeForm: {
        mobile: "",
        type: "resetPassword"
      },
      /*登录校验规则*/
      resetPwdFormRules: {
        username: [
          { required: true, message: "请输入账号", trigger: "blur" },
          { pattern: /^1[3-9]\d{9}$/, message: "请输入正确的手机号码", trigger: "blur" },
          // { validator:validateUsername,trigger: "blur"}
        ],
        trueName: [
          { required: true, message: "请输入姓名", trigger: "blur" },
        ],
        orgId: [
          { required: true, message: "请选择学校", trigger: "blur" },
        ],
        code: [{ required: true, message: "请输入6位数字验证码", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        newPassword: [{ required: true, message: "请再次输入新密码", trigger: "blur" }],
      }
    }
  },
  created() {
    this.getOrgListTypeOrg();
  },
  methods: {
    getOrgListTypeOrg() {
      authserviceSchoolList().then(res => {
        this.orgList = res.data.data;
        console.log(res);
      })
      // orgListTypeOrg({ orgType: 3 }).then(res => {
      //   this.orgList = res.data.data;
      // })
    },
    handleResetPwd() {
      this.$refs.resetPwdFormRef.validate(valid => {
        if (!valid) return
        if (this.resetPwdForm.password !== this.resetPwdForm.newPassword) {
          this.$message.error("两次密码输入不一致")
          return;
        }
        this.resetPwdBtnLoading = true
        // let pwd = this.$encrypt(this.resetPwdForm.password)
        let pwd = this.resetPwdForm.password

        let resetForm = { username: this.resetPwdForm.username, code: this.resetPwdForm.code, password: this.resetPwdForm.password, orgId: this.resetPwdForm.orgId, trueName: this.resetPwdForm.trueName }
        register(resetForm).then(res => {
          if (res.data.code === 1) {
            this.resetPwdBtnLoading = false
            /*去登录*/
            this.$confirm("您的账号注册成功，请等待审核！", "提示", {
              confirmButtonText: "去登录",
              cancelButtonText: "留在此页",
              type: "warning"
            }).then(() => {
              this.$router.push({ path: "/login" });
            })
          } else {
            this.$message.error(res.data.msg)
            this.resetPwdBtnLoading = false
          }
        })
      })
    },
    toRes() {
      window.location.href = "https://zhuce.zbform.com"
    },
    toPwdLogin() {
      this.$router.push("/login")
    },
    toCodeLogin() {
      this.$router.push("/codeLogin")
    },
    toHome() {
      this.$router.push("/indexs")
    },
    /*获取验证码*/
    getCode() {
      if (this.msgKey) return;
      if (this.resetPwdForm.username === '') {
        this.$message.error("请输入账号")
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.resetPwdForm.username)) {
        this.$message.error("请输入正确的手机号码")
        return;
      }
      this.codeBtnLoading = true
      this.codeForm.username = this.resetPwdForm.username
      requestCode(this.codeForm).then(res => {
        if (res.data.code === 1) {
          this.$message.success("验证码发送成功")
          this.codeBtnLoading = false
          this.codeTimer()
        } else {
          this.$message.error(res.data.msg)
          this.codeBtnLoading = false
        }
      })
    },
    codeTimer() {
      this.msgText = MSGSCUCCESS.replace("${time}", this.msgTime)
      this.msgKey = true
      const timer = setInterval(() => {
        this.msgTime--
        this.msgText = MSGSCUCCESS.replace("${time}", this.msgTime)
        if (this.msgTime == 0) {
          this.msgTime = MSGTIME
          this.msgText = MSGINIT
          this.msgKey = false
          clearInterval(timer)
        }
      }, 1000)
    }
  }
})
</script >
<!--样式-->
<style lang="scss" scoped>
.pwds {
  text-security: disc !important;
  -webkit-text-security: disc !important;
}

.login-page {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: url("../../assets/screen/loginBg.png") no-repeat center center;
  background-size: cover;
}

/*顶部 Logo*/
.login-header {
  position: absolute;
  top: 24px;
  left: 48px;
  display: flex;
  align-items: center;
  z-index: 3;
  cursor: pointer;

  .logo-img {
    width: 64px;
    height: 44px;
    border-radius: 50%;
    margin-right: 12px;
  }

  .logo-name {
    font-size: 26px;
    font-weight: 700;
    color: #ff7f2e;
    line-height: 1.2;
  }

  .logo-slogan {
    font-size: 13px;
    color: #d0942f;
    margin-top: 4px;
  }
}

/*注册卡片*/
.login-card {
  position: absolute;
  left: 6.5%;
  top: 120px;
  width: 600px;
  background: #ffffff;
  border-radius: 24px;
  padding-top: 32px;
  z-index: 2;
}

.login-form-wrap {
  width: 420px;
  margin: 0 auto;
}

.login-type {
  text-align: center;
  font-size: 26px;
  font-weight: 600;
  color: #ff7f2e;
  margin: 0 0 20px;
}

/deep/ .el-input__wrapper {
  height: 44px;
  background: #eef3f9;
  border-radius: 8px;
  box-shadow: 0 0 0 1px #d8e2ef inset;
}

/deep/ .el-input__wrapper.is-focus {
  box-shadow: 0 0 0 1px #ff7f2e inset;
}

/deep/ .el-input-group--append .el-input__wrapper {
  border-radius: 8px 0 0 8px;
}

/deep/ .el-input-group__append {
  background-color: #ff7f2e;
  color: #ffffff;
  font-size: 13px;
  border-radius: 0 8px 8px 0;
  box-shadow: none;
  padding: 0 16px;
}

/*学校下拉*/
/deep/ .el-select__wrapper {
  min-height: 44px;
  background: #eef3f9;
  border-radius: 8px;
  box-shadow: 0 0 0 1px #d8e2ef inset;
}

/deep/ .el-select__wrapper.is-focused {
  box-shadow: 0 0 0 1px #ff7f2e inset;
}

/deep/ .el-form-item {
  margin-bottom: 16px;
}

.loginBtn {
  width: 100%;
  height: 46px;
  font-size: 16px;
  border-radius: 8px;
  background: #ff7f2e;
  border-color: #ff7f2e;
}

.other-tab {
  display: flex;
  justify-content: space-between;
  margin-top: 4px;

  a {
    cursor: pointer;
    font-size: 14px;
    color: #ff7f2e;
  }

  a:hover {
    color: #ff7f2e;
  }
}

/*底部版权*/
.login-footer {
  padding: 28px 0 20px;
  text-align: center;
  font-size: 14px;
  color: #4c596e;

  a {
    text-decoration: none;
    color: #ff7f2e;
  }
}

/*右侧人物*/
.login-people {
  position: absolute;
  right: 7%;
  bottom: 0;
  height: 80%;
  z-index: 1;
}

@media screen and (max-width: 1100px) {
  .login-people {
    display: none;
  }
}
</style>
